<template>
	<page>
		<module>
			<view-list ref="view" :work-type="work_type" dynamic-field :field-sort="false" :view-config="auth('b_production_statistics_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="工单状态">
							<c-select name="work_states" :options="orderStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="工艺路线">
							<c-select name="route_ids" async multiple @search="searchProcessRoute" ></c-select>
						</m-search-item>
						<m-search-item label="生产人员">
							<c-select name="output_user_ids" async multiple @search="searchOutputUser" ></c-select>
						</m-search-item>
						<m-search-item label="时间维度字段">
							<c-select name="date_field" :options="dateFieldOptions" :clear="false"></c-select>
						</m-search-item>
						<m-search-item label="时间范围">
							<c-datetime type="date" :range="freeEdition ? {limit: 30} : true" start-name="start_date" end-name="end_date" :clear="false"></c-datetime>
						</m-search-item>
						<m-search-item label="统计维度">
							<c-select name="dimension_id" v-model="dimension_id" :options="dimensionOption.active" :disable-options="dimensionOption.disabled" :clear="false">
								<template #option="{data, selected, disabled}">
									<select-option
										:name="data.name"
										:selected="selected"
										:vip="disabled"
									></select-option>
								</template>
							</c-select>
						</m-search-item>
						<m-search-item label="工序" v-if="dimension_id == 113 || dimension_id == 115">
							<c-select name="process_ids" async multiple @search="searchProcess" ></c-select>
						</m-search-item>
						<m-search-item v-if="dimension_id == 111 || dimension_id == 110">
							<c-checkbox-group name="is_last_task">
								<c-checkbox value="1">工单最后产出</c-checkbox>
							</c-checkbox-group>
						</m-search-item>
						<m-search-item label="时间粒度">
							<c-select name="time_granule" :options="timeGranule" :clear="false"></c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_production_statistics_export')" v-lock="lock('b_production_statistics_export')" prepend-icon="tf-export" @click="$refs.view.exportReportByViewId()">导出</c-button>
				</template>
				
				<template #otherOperate>
					<c-button prepend-icon="tf-config" @click="indeicatorFieldConfig()">指标配置</c-button>
				</template>

				<!--工单状态-->
				<template #work_state="{data}">
					<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
				</template>
				<!--任务状态-->
				<template #task_state="{data}">
					<c-state dict="orderStateDic" tag :value="data.task_state"></c-state>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {
		data() {
			let now = new Date();
			return {
				work_type: 66,
				defaultSearchData: {
					dimension_id: 111,
					time_granule: 'DAY',
					date_field: 'create_date',
					start_date: new Date(now.getFullYear(), now.getMonth(), now.getDate()-6).format('yyyy-MM-dd'),
					end_date: new Date().format('yyyy-MM-dd'),
					is_last_task: [1]
				},
				dimension_id: 111
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['timeGranule', 'dateFieldOptions', 'orderStateDic']),
			...mapGetters(['freeEdition']),

			dimensionOption() {
				let options = [
					{name: '产品',value: 111},
					{name: '产品+工序',value: 113},
					{name: '产品+工单',value: 110},
					{name: '产品+工单+工序',value: 115}
				];

				return {
					active: options,
					disabled: this.freeEdition ? options.filter(item => item.name.includes('+')).map(item => item.value) : []
				}
			}
		},

		methods: {
			/*******搜索【工序】下拉框信息*****************/
			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			searchProcessRoute(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'PROCESSROUTE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/*******搜索【员工】下拉框信息*****************/
			searchOutputUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			//指标配置
			indeicatorFieldConfig(){
				this.globalDialog('indeicatorFieldConfig',{
					props: {
						work_type: this.work_type,
						view_id: this.$refs.view.getViewId()
					}
				}, this.updateTableList);
			},
			
			/****刷新列表****/
			updateTableList() {
				//刷新表头
				this.$refs.view.updateDynamicColumn();
				//刷新表数据
				this.$refs.view.update();
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>